<template>
    <div :class="selectedState ? 'selected' : ''">
        <div class="card card-body media-item noselect" v-if="prev" @click="handleClick">
            <i class="fa fa-arrow-up fa-7x"></i>
            <span class="name">..</span>
        </div>
        <div class="card card-body media-item noselect" v-else>
            <span class="restricted-badge" v-if="item.restricted"><i class="fa fa-lock"></i></span>
            <span class="unrestricted-badge" v-else><i class="fa fa-unlock"></i></span>
            <div class="dropdown icon-options">
                <button class="btn btn-sm btn-wellis-gold text-wellis-gold icon" @click="toggleOptions(item.path)">
                    <i class="fa fa-ellipsis-v"></i>
                </button>
                <div class="dropdown-menu dropdown-menu-right icon-options-menu" :id="`options_${item.path}`">
                    <a v-if="item.type === 'TYPE_FILE'" class="dropdown-item" href="javascript:void(0)" @click="download">{{$t('components.media.download')}}</a>
                    <a v-if="item.type === 'TYPE_FILE'" class="dropdown-item" href="javascript:void(0)" @click="selectFile">
                        <span v-if="!this.selectedState">{{$t('components.media.select-download')}}</span>
                        <span v-else>{{$t('components.media.unselect-download')}}</span>
                    </a>
                    <a v-if="$store.getters['authStore/isAdmin']" class="dropdown-item" href="javascript:void(0)"
                       @click="openRestrictionModal">{{$t('components.media.restrict')}}</a>
                </div>
            </div>
            <div @click="handleClick">
                <i :class="[resolveIcon(item.type, item.docType), 'd-block fa fa-5x', item.type === 'TYPE_DIR' ? 'fa-7x' : '']" v-if="item.thumbnail === null"></i>
                <div v-else style="overflow: hidden!important;height:80px; width:100%;margin-top:0;border-radius: 5px;">
                    <div class="thumbnail-cover" :style="`background-image: url('data:image/${item.extension};base64,${item.thumbnail}')`"></div>
                    <div class="thumbnail" :style="`background-image: url('data:image/${item.extension};base64,${item.thumbnail}')`"></div>
                </div>
                <span class="name" :title="`${item.name}.${item.extension}`" v-if="item.type === 'TYPE_FILE'">
                {{item.name | cut(13)}}.{{item.extension}}
            </span>
                <span class="name" :title="`${item.name}`" v-else>
                {{item.name | cut(13)}}
            </span>
                <div v-if="item.type === 'TYPE_FILE'">
                    <div class="d-block mt-1 mb-1">
                        {{item.size | niceBytesSize}}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import {EVENT_MEDIA_PREVIEW_IMAGE, EVENT_MEDIA_RESTRICT, EVENT_MEDIA_SELECT_FILE} from "@/core/constants";
import MediaApiService from "@/api/media.api";
import {handleDownloadedFile} from "@/helpers";

export default {
    name: "MediaItem",

    props: {
        item: Object,
        prev: Boolean,
        parentPath: String,
        currentPath: String,
        selectedState: Boolean
    },

    data() {
        return {
            restrictionModal: false,
        }
    },

    methods: {
        resolveIcon(type, docType) {
            if (type === 'TYPE_DIR') {
                return 'fa-folder';
            }
            let icon = '';
            switch (docType) {
                case 'DOC_TYPE_IMAGE':
                    icon = 'fa-image';
                    break;
                case 'DOC_TYPE_AUDIO':
                    icon = 'fa-file-audio';
                    break;
                case 'DOC_TYPE_VIDEO':
                    icon = 'fa-photo-video';
                    break;
                case 'DOC_TYPE_DOC':
                    icon = 'fa-file-pdf';
                    break;
                default:
                    icon = 'fa-question';
            }
            return icon;
        },

        handleClick() {
            if (this.prev) {
                this.$parent.getContent(this.parentPath);
            } else {
                if (this.item.type === 'TYPE_DIR') {
                    this.$parent.getContent(this.item.path);
                } else {
                    if (this.item.docType === 'DOC_TYPE_IMAGE') {
                        this.previewImage();
                    }
                }
            }
        },

        toggleOptions(path) {
            const others = document.getElementsByClassName('icon-options-menu');
            others.forEach(item => {
                if (item.getAttribute('id').indexOf(path) === -1) {
                    item.classList.remove('show');
                }
            });

            const el = document.getElementById(`options_${path}`);
            el.classList.toggle('show');
        },

        selectFile() {
            this.$eventBus.$emit(EVENT_MEDIA_SELECT_FILE, this.item);
        },

        previewImage() {
            this.$eventBus.$emit(EVENT_MEDIA_PREVIEW_IMAGE, this.item);
        },

        download() {
            let loader = this.$loading.show();
            MediaApiService.singleDownload(this.item.path)
                .then(blobFile => {
                    return handleDownloadedFile(blobFile.data, `${this.item.name}.${this.item.extension}`, blobFile.type);
                })
                .catch(() => {
                    this.$swal.fire({
                        icon: "error",
                        allowOutsideClick: false,
                        html: this.$t('api-error')
                    });
                })
                .finally(() => {
                    loader.hide();
                    loader = null;
                });
        },

        openRestrictionModal() {
            this.$eventBus.$emit(EVENT_MEDIA_RESTRICT, this.item);
        }
    }
}
</script>

<style scoped>

.selected {
    border: 2px solid #b89453;
    border-radius: 10px;
}

.media-item {
    text-align: center;
    border: 1px solid darkgrey;
    border-radius: 10px;
    cursor: pointer;
}

.media-item:hover {
    color: #b89453 !important;
    border: 1px solid #b89453;
}

.name {
    font-size: 13px;
}

.icon-options {
    position: absolute;
    margin-left: 190px;
    top: 0;
    right: -15px;
    z-index: 10;
}

.media-item > .icon-options {
    opacity: 0;
}

.media-item:hover > .icon-options {
    opacity: 1;
}

.thumbnail {
    background-position: center;
    height: 80px;
    background-size: contain;
    background-repeat: no-repeat;
    position: absolute;
    top: 20px;
    left: 4px;
    width: 98%;
}

.thumbnail-cover {
    height: 84px;
    filter: blur(5px);
    -webkit-filter: blur(5px);
    background-size: 100%;
    background-repeat: no-repeat;
    background-position: center;
    width: 110%;
    margin-left: -2px;
    margin-top: -2px;
}

.restricted-badge {
    position: absolute;
    left: -15px;
    top: -15px;
    background: #b89453 !important;
    color: white;
    text-align: center;
    border-radius: 30px 30px 30px 30px;
    padding: 5px 10px;
    font-size: 20px;
    z-index: 10;
}

.unrestricted-badge {
    position: absolute;
    left: -15px;
    top: -15px;
    background-color: #f4f4f4;
    color: #000;
    text-align: center;
    border-radius: 30px 30px 30px 30px;
    padding: 5px 10px;
    font-size: 20px;
    z-index: 10;
}
</style>
